module.exports = __webpack_public_path__ + "static/media/Banner-Supermee-mobile.5f6860cf.png";